import moment from "moment";
import React from "react";

import { Icon, Icomoon, PrimaryButton } from "../../../core/atoms/atoms";
import { CustomerRequiredDetailsProgress } from "../../components/customer/customerRequiredDetailsProgress";
import ContactCard from "./contactCard";

import "./customerRequiredDetailsReview.scss";

interface OwnProps {
  currentStage: number;
  maxStages: number;
  showPaymentStage: () => void;
  leadTravelerDetails: ILeadTravelerDetails;
  travelerDetails: ITravelerDetails[];
  addTraveler: () => void;
  editTraveler: () => void;
}

export class CustomerRequiredDetailsReview extends React.Component<OwnProps> {

  private capitaliseTitle(title) {
    return title[0].toUpperCase() + title.substring(1) + ".";
  }

  private renderTravelerDetails(details, leadTraveler, editTraveler, key, travelerDetails) {
    const {
      title,
      otherTitle,
      firstName,
      lastName,
      passportIssuingCountry,
      dateOfBirth,
      countryOfResidence,
    } = details;

    const formatDateOfBirth = moment(dateOfBirth.value, "YYYY-MM-DD").format("Do MMMM YYYY");

    let selectedTitle;
    if (otherTitle) {
      selectedTitle = this.capitaliseTitle(otherTitle);
    }
    else {
      selectedTitle = this.capitaliseTitle(title);
    }

    return (
      <div className="traveler-card-details-wrapper">
        <div className="traveler-card-details-header">
          {leadTraveler ? <h3>Lead traveller</h3> : <h3>Traveller {key + 2} of {travelerDetails.length + 1}</h3>}

          <button type="button" className="secondary-button" onClick={() => editTraveler(leadTraveler, key)}>
            <Icon icomoon={Icomoon.pencil} />
            Edit
          </button>
        </div>
        <ul className="traveler-card-details">
          <li className="traveler-card-details-item">
            <p className="traveler-card-details-item-title">Name</p>
            <p>{selectedTitle} {firstName} {lastName}</p>
          </li>
          <li className="traveler-card-details-item">
            <p className="traveler-card-details-item-title">Passport issuing country</p>
            <p>{passportIssuingCountry.name}</p>
          </li>
          <li className="traveler-card-details-item">
            <p className="traveler-card-details-item-title">Date of birth</p>
            <p>{formatDateOfBirth}</p>
          </li>
          {leadTraveler &&
            <li className="traveler-card-details-item">
              <p className="traveler-card-details-item-title">Country of residence</p>
              <p>{countryOfResidence.name}</p>
            </li>
          }
        </ul>
      </div>
    );
  }

  public render() {
    const {
      currentStage,
      maxStages,
      leadTravelerDetails,
      travelerDetails,
      showPaymentStage,
      addTraveler,
      editTraveler,
    } = this.props;

    return (
      <div className="required-details-review">
        <CustomerRequiredDetailsProgress
          stage={currentStage}
          maxStages={maxStages}
        />
        <h2 className="review-heading">
          Review your traveller details
        </h2>
        <ul className="traveler-details">
          {leadTravelerDetails &&
            <li className="traveler-card">
              {this.renderTravelerDetails(leadTravelerDetails, true, editTraveler, null, travelerDetails)}
            </li>
          }
          {travelerDetails?.map((traveler, i) =>
            <li className="traveler-card" key={traveler.id}>
              {this.renderTravelerDetails(traveler, false, editTraveler, i, travelerDetails)}
            </li>,
          )}
        </ul>
        <div className="add-traveler">
          <h2>Is everyone here?</h2>
          <p>We need information for everyone who will be travelling as part of this booking,{" "}
            including children under 2 years old.</p>
          
          <button type="button" className="secondary-button" onClick={addTraveler}>
            <Icon icomoon={Icomoon.plus2} />
            Add another traveller
          </button>
        </div>

        <button type="button" className="review-confirm primary-button" onClick={showPaymentStage}>
          <span>Confirm and proceed</span>
          <Icon className="right-icon" icomoon={Icomoon.arrowRight12} />
        </button>
        <ContactCard />
      </div>
    );
  }
}
